@if (templatedTask != null) {
  <div class="tle-card">

    <!-- ============ Header ============ -->
    <div class="tle-header">
      <div class="tle-header-icon">
        <mat-icon>fact_check</mat-icon>
      </div>
      <div class="tle-header-main">
        <div class="tle-eyebrow">{{ id == 'add' ? 'New templated task' : 'Templated task' }}</div>
        <input
          class="tle-name-input"
          placeholder="Name this task"
          [(ngModel)]="templatedTask.name"
          (focus)="nameFocusState = true"
          (focusout)="nameFocusState = false">
        <div class="tle-field-hint" [class.show]="nameFocusState">
          Library name only — it won't show up on the calendar event
        </div>
      </div>
      @if (id != 'add') {
        <button class="tle-delete-btn" type="button" title="Delete task" (click)="delete()">
          <mat-icon>delete_outline</mat-icon>
        </button>
      }
    </div>

    <!-- ============ Details ============ -->
    <div class="tle-details">

      <div class="tle-field tle-span-2">
        <label class="tle-label">Description <span class="tle-label-note">· shows on the calendar event</span></label>
        <input
          class="tle-input"
          placeholder="What needs to be done?"
          [(ngModel)]="templatedTask.description">
      </div>

      <div class="tle-field">
        <label class="tle-label">Scheduling</label>
        <div class="tle-inline">
          <button
            type="button"
            class="tle-flag"
            [class.on]="templatedTask.anyTime"
            (click)="templatedTask.anyTime = !templatedTask.anyTime">
            <mat-icon>{{ templatedTask.anyTime ? 'check' : 'schedule' }}</mat-icon>
            Anytime
          </button>
          @if (!templatedTask.anyTime) {
            <input
              class="tle-input tle-time"
              type="time"
              [(ngModel)]="templatedTask.startTime">
          }
        </div>
      </div>

      <div class="tle-field">
        <label class="tle-label">Estimated time <span class="tle-label-note">· minutes</span></label>
        <input
          class="tle-input"
          type="number"
          placeholder="e.g. 30"
          [(ngModel)]="templatedTask.estimatedTime">
      </div>

      <div class="tle-field tle-span-2">
        <label class="tle-label">Options</label>
        <div class="tle-inline">
          <button
            type="button"
            class="tle-flag warn"
            [class.on]="templatedTask.highPriority"
            (click)="templatedTask.highPriority = !templatedTask.highPriority">
            <mat-icon>flag</mat-icon>
            High priority
          </button>
          <button
            type="button"
            class="tle-flag"
            [class.on]="templatedTask.timeSpentRequired"
            (click)="templatedTask.timeSpentRequired = !templatedTask.timeSpentRequired">
            <mat-icon>timer</mat-icon>
            Require time spent
          </button>
        </div>
      </div>

      <div class="tle-field">
        <label class="tle-label">Tags</label>
        <app-chip-list-edit [label]="'Tags'" [allChips]="allTags" [(chips)]="templatedTask.tags"></app-chip-list-edit>
      </div>

      <div class="tle-field">
        <label class="tle-label">Teams</label>
        <app-team-select-multiple [(teamIds)]="templatedTask.assignedTeamIds"></app-team-select-multiple>
      </div>

    </div>

    <!-- ============ Task content sections ============ -->
    <div class="tle-sections">
      <div class="tle-sections-title">Task content</div>

      <!-- Subtasks -->
      <div class="tle-section" [class.open]="sections.subtasks">
        <button type="button" class="tle-section-head" (click)="toggleSection('subtasks')">
          <span class="tle-section-icon subtasks"><mat-icon>event_list</mat-icon></span>
          <span class="tle-section-name">Subtasks</span>
          <span class="tle-section-preview" [class.empty]="subtaskCount === 0">{{ subtasksPreview }}</span>
          @if (subtaskCount > 0) { <span class="tle-count">{{ subtaskCount }}</span> }
          <mat-icon class="tle-chevron">expand_more</mat-icon>
        </button>
        @if (sections.subtasks) {
          <div class="tle-section-body">
            @if (subtaskCount === 0) {
              <div class="tle-empty">Break this task into a checklist workers complete one by one.</div>
            }
            @if (subtaskCount > 0) {
              <div cdkDropList class="tle-drag-list" (cdkDropListDropped)="dropSubtask($event)">
                @for (subtask of templatedTask.subtasks; track subtask; let i = $index) {
                  <div class="tle-drag-item" cdkDrag>
                    <div class="tle-drag-placeholder" *cdkDragPlaceholder></div>
                    <div class="tle-row">
                      <span class="tle-drag-handle" cdkDragHandle><mat-icon>drag_indicator</mat-icon></span>
                      <input
                        class="tle-row-input"
                        placeholder="Subtask title"
                        [ngModel]="subtask.title"
                        (ngModelChange)="subtask.title = $event">
                      <button
                        type="button"
                        class="tle-row-btn"
                        [class.active]="hasDescription(subtask) || expandedSubtasks.has(subtask)"
                        title="Add details"
                        (click)="toggleSubtaskDescription(subtask)">
                        <mat-icon>notes</mat-icon>
                      </button>
                      <button type="button" class="tle-row-btn danger" title="Remove subtask" (click)="removeSubtask(i)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                    @if (expandedSubtasks.has(subtask)) {
                      <textarea
                        class="tle-row-textarea"
                        placeholder="Details for this subtask…"
                        [ngModel]="subtask.description"
                        (ngModelChange)="subtask.description = $event"></textarea>
                    }
                  </div>
                }
              </div>
            }
            <button type="button" class="tle-add-btn" (click)="addSubtask()">
              <mat-icon>add</mat-icon>Add subtask
            </button>
          </div>
        }
      </div>

      <!-- Data collection -->
      <div class="tle-section" [class.open]="sections.data">
        <button type="button" class="tle-section-head" (click)="toggleSection('data')">
          <span class="tle-section-icon data"><mat-icon>query_stats</mat-icon></span>
          <span class="tle-section-name">Data collection</span>
          <span class="tle-section-preview" [class.empty]="dataCount === 0">{{ dataPreview }}</span>
          @if (dataCount > 0) { <span class="tle-count">{{ dataCount }}</span> }
          <mat-icon class="tle-chevron">expand_more</mat-icon>
        </button>
        @if (sections.data) {
          <div class="tle-section-body">
            @if (dataCount === 0) {
              <div class="tle-empty">Ask workers to record measurements from your Data Library when completing this task.</div>
            }
            @if (dataCount > 0) {
              <div cdkDropList class="tle-drag-list" (cdkDropListDropped)="dropDataDef($event)">
                @for (def of templatedTask.dataCollectionDefinitions; track def; let i = $index) {
                  <div class="tle-drag-item" cdkDrag>
                    <div class="tle-drag-placeholder" *cdkDragPlaceholder></div>
                    <div class="tle-row">
                      <span class="tle-drag-handle" cdkDragHandle><mat-icon>drag_indicator</mat-icon></span>
                      <select
                        class="tle-row-select"
                        [ngModel]="def.id"
                        (ngModelChange)="onDataDefChange(i, $event)">
                        <option [ngValue]="null" disabled>Select from Data Library…</option>
                        @for (option of dataLibrary; track option.id) {
                          <option [ngValue]="option.id">{{ option.name }}{{ option.unit != null ? ' (' + getUnit(option.unit) + ')' : '' }}</option>
                        }
                      </select>
                      <button type="button" class="tle-row-btn danger" title="Remove field" (click)="removeDataDef(i)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>
            }
            <div class="tle-body-footer">
              <button type="button" class="tle-add-btn" (click)="addDataDef()">
                <mat-icon>add</mat-icon>Add data field
              </button>
              <button type="button" class="tle-link-btn" (click)="openDataLibrary()">
                Open Data Library<mat-icon>open_in_new</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>

      <!-- Notes -->
      <div class="tle-section" [class.open]="sections.notes">
        <button type="button" class="tle-section-head" (click)="toggleSection('notes')">
          <span class="tle-section-icon notes"><mat-icon>sticky_note_2</mat-icon></span>
          <span class="tle-section-name">Notes</span>
          <span class="tle-section-preview" [class.empty]="noteCount === 0">{{ notesPreview }}</span>
          @if (noteCount > 0) { <span class="tle-count">{{ noteCount }}</span> }
          <mat-icon class="tle-chevron">expand_more</mat-icon>
        </button>
        @if (sections.notes) {
          <div class="tle-section-body">
            @if (noteCount === 0) {
              <div class="tle-empty">Notes travel with the task onto every event created from it.</div>
            }
            @for (note of templatedTask.notes; track $index; let i = $index) {
              <div class="tle-row">
                <input
                  class="tle-row-input"
                  placeholder="Write a note…"
                  [ngModel]="templatedTask.notes[i]"
                  (ngModelChange)="templatedTask.notes[i] = $event">
                <button type="button" class="tle-row-btn danger" title="Remove note" (click)="removeNote(i)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
            <button type="button" class="tle-add-btn" (click)="addNote()">
              <mat-icon>add</mat-icon>Add note
            </button>
          </div>
        }
      </div>

      <!-- Attachments -->
      <div class="tle-section" [class.open]="sections.attachments">
        <button type="button" class="tle-section-head" (click)="toggleSection('attachments')">
          <span class="tle-section-icon attachments"><mat-icon>attachment</mat-icon></span>
          <span class="tle-section-name">Attachments</span>
          <span class="tle-section-preview" [class.empty]="attachmentCount === 0">{{ attachmentsPreview }}</span>
          @if (attachmentCount > 0) { <span class="tle-count">{{ attachmentCount }}</span> }
          <mat-icon class="tle-chevron">expand_more</mat-icon>
        </button>
        @if (sections.attachments) {
          <div class="tle-section-body">
            @if (attachmentCount === 0) {
              <div class="tle-empty">Attach SOPs, checklists, or reference documents from your company files.</div>
            }
            @if (attachmentCount > 0) {
              <div class="tle-attach-list">
                @for (attachmentId of templatedTask.attachments; track attachmentId; let i = $index) {
                  <div class="tle-attach-chip">
                    <app-attachment-btn [id]="attachmentId"></app-attachment-btn>
                    <button type="button" class="tle-row-btn danger" title="Remove attachment" (click)="removeAttachment(i)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                }
              </div>
            }
            <button type="button" class="tle-add-btn" (click)="attachmentsClick()">
              <mat-icon>add</mat-icon>Choose attachments
            </button>
          </div>
        }
      </div>

      <!-- Cloud links -->
      <div class="tle-section" [class.open]="sections.cloud">
        <button type="button" class="tle-section-head" (click)="toggleSection('cloud')">
          <span class="tle-section-icon cloud"><mat-icon>cloud</mat-icon></span>
          <span class="tle-section-name">Cloud links</span>
          <span class="tle-section-preview" [class.empty]="cloudCount === 0">{{ cloudPreview }}</span>
          @if (cloudCount > 0) { <span class="tle-count">{{ cloudCount }}</span> }
          <mat-icon class="tle-chevron">expand_more</mat-icon>
        </button>
        @if (sections.cloud) {
          <div class="tle-section-body">
            @if (cloudCount === 0) {
              <div class="tle-empty">Link out to Google Drive, Dropbox, or any URL workers should have handy.</div>
            }
            @for (link of templatedTask.cloudAttachments; track $index; let i = $index) {
              <div class="tle-row">
                <span class="tle-row-prefix"><mat-icon>link</mat-icon></span>
                <input
                  class="tle-row-input"
                  placeholder="https://…"
                  [ngModel]="templatedTask.cloudAttachments[i]"
                  (ngModelChange)="templatedTask.cloudAttachments[i] = $event">
                @if (templatedTask.cloudAttachments[i]) {
                  <a class="tle-row-btn" [href]="templatedTask.cloudAttachments[i]" target="_blank" rel="noopener" title="Open link">
                    <mat-icon>open_in_new</mat-icon>
                  </a>
                }
                <button type="button" class="tle-row-btn danger" title="Remove link" (click)="removeCloudLink(i)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
            <button type="button" class="tle-add-btn" (click)="addCloudLink()">
              <mat-icon>add</mat-icon>Add link
            </button>
          </div>
        }
      </div>

    </div>
  </div>

  <!-- ============ Sticky save bar ============ -->
  @if (dirty) {
    <div class="tle-savebar">
      <span class="tle-savebar-dot"></span>
      <span class="tle-savebar-msg">{{ id == 'add' ? 'New task — not saved yet' : 'Unsaved changes' }}</span>
      <span class="tle-savebar-spacer"></span>
      <button type="button" class="tle-btn ghost" [disabled]="saving" (click)="undo()">
        {{ id == 'add' ? 'Cancel' : 'Discard' }}
      </button>
      <button type="button" class="tle-btn primary" [disabled]="saving" (click)="save()">
        @if (saving) {
          <mat-spinner diameter="18" strokeWidth="3"></mat-spinner>
        }
        {{ saving ? 'Saving…' : 'Save task' }}
      </button>
    </div>
  }
}
